<app-header></app-header>
<div class="page-content">
  <h2 class="webapp-title-secondary">Aplicaciones</h2>

  <div class="grid grid-cols-2 grid-gap">
    <a href="javascript:void(0)" class="category-item link" *ngFor="let app of getVisibleSections()" (click)="navigateToApp(app)">
      <img [src]="getImageUrl(app)" alt="">
      <div class="category-name">{{app.name}}</div>
    </a>
    
  </div>

  <app-card-utility [cardInfo]="usefulResources" (ctaClicked)="buyProductSimple('videocall60')"></app-card-utility>
  
</div>

<app-footer></app-footer>